module.exports = __webpack_public_path__ + "static/media/ICICI_Prudential_Mutual_Fund.4da2ff5d.pdf";